module.exports = __webpack_public_path__ + "img/priority-highest.4902c4e0.svg";